// form要素に変更があり、遷移が発生する場合にアラートを出します
// `data-prevent-moving` data属性を持つformが発火対象となります
document.addEventListener('DOMContentLoaded', () => {
  const targetForm = document.querySelector('form[data-prevent-moving]')
  if (!targetForm) {
    return false
  }

  let isChanged = false
  const onBeforeunload = e => {
    if (!isChanged) {
      return
    }
    // EdgeとIEのみ表示テキストを変更可能
    // それ以外はブラウザ表示に依存します
    e.returnValue = targetForm.getAttribute('data-prevent-moving')
  }
  // form要素の変更でフラグを立てる
  targetForm.addEventListener('change', () => {
    isChanged = true
  })
  // submitでは発火させない
  targetForm.addEventListener('submit', () => {
    isChanged = false
  })

  // ページ遷移時にアラート出す
  return window.addEventListener('beforeunload', onBeforeunload, false)
})
